module.exports = __webpack_public_path__ + "img/gartek-services-electrical-know.dfaceb53.png";